<template>
  <div>
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <b-form>
              <b-row>
                <b-col
                  sm="12"
                  md="4"
                  lg="4"
                  xl="4"
                >
                  <b-form-group
                    :label="trainingSystemLabel"
                    label-for="trainingSystem"
                  >
                    <v-select
                      id="trainingSystem"
                      v-model="filter.trainingSystemId"
                      label="name"
                      :options="trainingSystems"
                      :reduce="(option) => option.id"
                      :clearable="false"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  md="4"
                  lg="4"
                  xl="4"
                >
                  <b-form-group
                    label="Khóa học"
                    label-for="course"
                  >
                    <v-select
                      id="course"
                      v-model="filter.courseId"
                      label="name"
                      :options="courses"
                      :reduce="(option) => option.id"
                      :clearable="false"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  md="4"
                  lg="4"
                  xl="4"
                >
                  <b-form-group
                    label="Năm học"
                    label-for="yearId"
                  >
                    <v-select
                      id="yearId"
                      v-model="filter.yearId"
                      label="name"
                      :options="years"
                      :reduce="(option) => option.id"
                      @input="onChangeYear"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  sm="12"
                  md="4"
                  lg="4"
                  xl="4"
                >
                  <b-form-group
                    label="Học kỳ"
                    label-for="semester"
                  >
                    <v-select
                      id="semester"
                      v-model="filter.courseSemesterId"
                      label="name"
                      :options="courseSemesters"
                      :reduce="(option) => option.id"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  md="4"
                  lg="4"
                  xl="4"
                >
                  <b-form-group
                    label="Lớp cố định"
                    label-for="classId"
                  >
                    <v-select
                      id="classId"
                      v-model="filter.classId"
                      label="name"
                      :options="classes"
                      :reduce="(option) => option.id"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <div class="w-100 d-flex justify-content-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      class="mr-1"
                      @click="getDataSourcesFromStore"
                    >
                      <span class="text-nowrap text-right">
                        <feather-icon icon="SearchIcon" /> Tìm kiếm
                      </span>
                    </b-button>

                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-primary"
                      @click="exportExcel"
                    >
                      <span class="text-nowrap text-right">
                        <feather-icon icon="DownloadIcon" /> Xuất excel
                      </span>
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-form>
            <b-row class="mt-2">
              <b-col cols="12">
                <vue-good-table
                  :columns="columns"
                  :rows="dataSources"
                  :total-rows="total"
                  :pagination-options="paginationOptions"
                  :line-numbers="true"
                >
                  <div
                    slot="emptystate"
                    style="text-align: center; font-weight: bold"
                  >
                    Không có bản ghi nào !
                  </div>
                  <template
                    slot="table-row"
                    slot-scope="props"
                  >
                    <span v-if="props.column.field === 'creditClassCode' || props.column.field === 'creditClassName'">
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </template>

                  <!-- pagination -->
                  <template
                    slot="pagination-bottom"
                    slot-scope="props"
                  >
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị 1 đến </span>
                        <b-form-select
                          v-model="filter.itemsPerPage"
                          :options="itemsPerPageOptions"
                          class="mx-1"
                          @input="(value) => props.perPageChanged({ currentPerPage: value })"
                        />
                        <span class="text-nowrap">của {{ props.total }} bản ghi</span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="props.total"
                          :per-page="filter.itemsPerPage"
                          class="mt-1 mb-0"
                          @input="(value) => props.pageChanged({ currentPage: value })"
                        />
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BContainer,
  BForm,
  BFormGroup,
  BFormSelect,
  BOverlay,
  BPagination,
  BRow,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getUser } from '@/auth/utils'
import { VueGoodTable } from 'vue-good-table'
import * as XLSX from 'xlsx'
import api from './api'
import { OrganizationCode } from '@/const/code';

export default {
  name: 'ReportConductPointByCourse',
  directives: {
    Ripple,
  },
  components: {
    BOverlay,
    BPagination,
    vSelect,
    BFormSelect,
    BFormGroup,
    BCol,
    BContainer,
    BButton,
    BForm,
    BCard,
    BRow,
    VueGoodTable,
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      filter: {
        itemsPerPage: 20,
        trainingSystemId: null,
        courseId: null,
        yearId: null,
        courseSemesterId: null,
        classId: null,
      },
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      columns: [],
      defaultColumns: [
        {
          label: 'Mã sinh viên',
          field: 'studentCode',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Họ và tên',
          field: 'fullName',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Ngày sinh',
          field: 'birthday',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Lớp',
          field: 'classCode',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'TB điểm rèn luyện',
          field: 'conductAvg',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Xếp loại',
          field: 'conductRank',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
      trainingSystems: [],
      courses: [],
      years: [],
      courseSemesters: [],
      classes: [],
      dataSources: [],
      total: 0,
      courseSemesterByFilter: [],
    }
  },
  computed: {
    paginationOptions() {
      return {
        enabled: true,
        perPage: this.filter.itemsPerPage,
      }
    },
    trainingSystemLabel() {
      return getUser().orgCode === OrganizationCode.HLUV ? 'Hệ đào tạo' : 'Hình thức đào tạo'
    },
  },
  watch: {
    'filter.trainingSystemId': async function (val) {
      if (val) {
        this.isLoading = true
        try {
          const res = await api.getCoursesByTrainingSystemId({ trainingSystemId: val })
          this.courses = res
          if (this.courses.length > 0) {
            this.updateParams({ courseId: this.courses[0].id })
          } else {
            this.updateParams({
              courseId: null,
              courseSemesterId: null,
              classId: null,
            })
            this.courses = []
            this.courseSemesters = []
            this.classes = []
          }
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isLoading = false
        }
      } else {
        this.updateParams({
          courseId: null,
          courseSemesterId: null,
          classId: null,
        })
        this.courses = []
        this.courseSemesters = []
        this.classes = []
      }
    },
    'filter.courseId': async function (val) {
      if (val) {
        this.isLoading = true
        try {
          const resYear = await api.getYears({ courseId: val })
          this.years = resYear
          if (this.years.length > 0) {
            this.updateParams({ yearId: this.years[0].id })
          }
          const res = await api.getCourseSemesterByCourseIdAndYearId({
            courseId: val,
            yearId: this.filter.yearId,
          })
          this.courseSemesters = res
          if (this.courseSemesters.length > 0) {
            this.updateParams({ courseSemesterId: this.courseSemesters[0].id })
          } else {
            this.updateParams({
              courseSemesterId: null,
            })
            this.courseSemesters = []
          }
          const resClass = await api.getClassByCourseId({
            courseId: val,
          })
          this.classes = resClass
          if (this.classes.length > 0) {
            this.updateParams({ classId: this.classes[0].id })
          } else {
            this.updateParams({
              classId: null,
            })
            this.classes = []
          }
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isLoading = false
        }
      } else {
        this.updateParams({
          courseSemesterId: null,
          classId: null,
        })
        this.courseSemesters = []
        this.classes = []
      }
    },
  },
  async created() {
    this.reset()
    this.isLoading = true
    try {
      this.columns = this.defaultColumns
      const resTrainingSystem = await api.getTrainingSystemsByOrganizationId({ organizationId: this.user.orgId })
      this.trainingSystems = resTrainingSystem
      if (this.trainingSystems.length > 0) {
        this.updateParams({ trainingSystemId: this.trainingSystems[0].id })
      }
    } catch (e) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `[${e.code}] ${e.message}`,
          icon: 'XCircleIcon',
          variant: 'danger',
        },
      })
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    reset() {
      this.updateParams({
        trainingSystemId: null,
        courseId: null,
        yearId: null,
        courseSemesterId: null,
        classId: null,
      })
      this.trainingSystems = []
      this.courses = []
      this.years = []
      this.courseSemesters = []
      this.classes = []
      this.dataSources = []
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onChangeYear() {
      const res = await api.getCourseSemesterByCourseIdAndYearId({
        courseId: this.filter.courseId,
        yearId: this.filter.yearId,
      })
      this.courseSemesters = res
      if (this.courseSemesters.length > 0) {
        this.updateParams({ courseSemesterId: this.courseSemesters[0].id })
      } else {
        this.updateParams({
          courseSemesterId: null,
        })
        this.courseSemesters = []
      }
    },
    async getDataSourcesFromStore() {
      this.isLoading = true
      try {
        this.columns = [...this.defaultColumns]
        this.courseSemesterByFilter = []
        const resCourseSemester = await api.getConvertCourseSemester({
          courseId: this.filter.courseId,
          yearId: this.filter.yearId,
          courseSemesterId: this.filter.courseSemesterId,
        })
        this.courseSemesterByFilter = resCourseSemester
        if (this.courseSemesterByFilter.length > 0) {
          const index = this.columns.findIndex(col => col.field === 'classCode')
          if (index !== -1) {
            this.courseSemesterByFilter.forEach((item, i) => {
              this.columns.splice(index + 1 + i, 0, {
                label: item.name,
                field: item.code,
                sortable: false,
                thClass: 'text-center',
                tdClass: 'text-center',
              })
            })
          }
        }
        const res = await api.getReportConductPoint({
          trainingSystemId: this.filter.trainingSystemId,
          courseId: this.filter.courseId,
          yearId: this.filter.yearId,
          courseSemesterId: this.filter.courseSemesterId,
          classId: this.filter.classId,
        })
        this.dataSources = res.data.records
        this.total = res.data.total
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Khóa học được chọn không tồn tại trong năm học!',
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    exportExcel() {
      if (this.dataSources.length === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Không có dữ liệu để xuất!',
            icon: 'InfoIcon',
            variant: 'warning',
          },
        })
        return
      }
      const data = []
      const header = {}
      this.columns.forEach(column => {
        header[column.field] = column.label
      })
      const headerKeys = Object.keys(header)
      const dataSourceKeys = Object.keys(this.dataSources[0])
      const duplicates = dataSourceKeys.filter(val => headerKeys.includes(val))
      duplicates.sort((a, b) => headerKeys.indexOf(a) - headerKeys.indexOf(b))
      this.dataSources.forEach(dataSource => {
        const elm = {}
        duplicates.forEach(key => {
          elm[header[key]] = dataSource[key]
        })
        data.push(elm)
      })
      const ws = XLSX.utils.json_to_sheet(data)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'SoLuong')
      XLSX.writeFile(wb, 'BaoCaoDiemRenLuyenTrungBinhKhoa.xlsx')
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
